import { OtoIndividualPlace } from '../../lib/types/models/journey-place/oto-individual-place'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getOtoIndividualPlaces(journeyPlaceId: number) {
  return restApiClient
    .url(constructApiUrl(API.journeyPlaces.getOtoIndividualPlaces.url, { id: journeyPlaceId }))
    .get<OtoIndividualPlace[]>()
}
